export default __webpack_public_path__ + "static/media/herocard1.2f096805.svg";